import {
    get,
    post
} from '../utils/request';
// 获取运动员列表
export const getAthleteList = params => get('/athlete/list', params);
// 获取注册员表单信息-教练员列表
export const getCoachList = params => get('/coach/listConcise', params);
// 运动员注册
export const addAthletes = params => post('/athlete/add', params);
// 获取运动员详情
export const getAthletesDetails = params => get('/athlete/detail', params);
// 修改运动员
export const updateAthletes = params => post('/athlete/update',params);
// 分会审核
export const societyAudit = params=>post('/athlete/societyAudit',params);
// 学校审核
export const schoolAudit = params=>post('/athlete/schoolAudit',params);
// 获取学校列表
export const getSchool = params => get('/member/getSchoolList',params);
/**
 * 运动员统计列表
 * @param {refereeRank} 裁判员等级(国际级、国家级、荣誉级、一级、二级)
 */
export const getAthleteCountList = params => get('/statistics/getAthleteCountList',params);
// 删除运动员
export const deleteAthlete = params => post('/athlete/delete',params); 